<template>
  <base-section
  id="hero"
  space="0"
  >
    <v-img
      :max-height="minHeight"
      :src="require('@/assets/lyon_bg.jpg')"
      gradient="to bottom, rgba(0, 51, 153, 100), rgba(255,255,255,.2)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center mx-auto"
          :height="$vuetify.breakpoint.mdAndUp ? '90%' : 'auto'"
          width="100%"
        >
        <!--
          <v-img
          :src="require('@/assets/logo.png')"
          max-height="150"
          width="100%"
          contain
          id="img2"
          />
        -->
          <base-heading
            size="text-h2"
            weight="bold"
            id="heading1"
            title="28th IEEE International Symposium on Design and Diagnostics of Electronic Circuits and Systems (DDECS)"
          />

          <base-subheading
            size="text-h3"
            weight="bold"
            id="heading2"
            title="May 5-7 in Lyon, France"
          />
          <div class="d-flex flex-md-row flex-column">
            <!-- Left side buttons container -->
            <div class="d-flex flex-column pa-2">
              <div class="mb-4">
                <v-badge
                  bordered
                  color="accent"
                  overlap
                >
                  <base-btn
                    to="keynotes"
                  >
                    Keynotes News
                  </base-btn>
                </v-badge>
              </div>

              <div>
                <v-badge
                  bordered
                  color="accent"
                  overlap
                >
                  <base-btn
                    to="cfp"
                  >
                    Call for Papers
                  </base-btn>
                </v-badge>
              </div>
            </div>

            <!-- Right side alert -->
            <news-section
              :latestNews="latestNews"
              class="ml-md-auto align-self-center elevation-20 mt-mobile"
            >
            </news-section>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </base-section>
</template>

<script>
import NewsSection from "@/components/base/NewsSection.vue"

  export default {
    name: 'SectionHero',
    components: {
      NewsSection,
    },
    provide: {
      theme: { isDark: false },
    },
    data: () => ({
      latestNews: [
      {
          date: 'January 3, 2025',
          text: 'Deadlines extension',
          link: '/cfp',
      },
      {
          date: 'January 3, 2025',
          text: 'Keynote announcement: Lukas Sekanina',
          link: '/keynotes',
      },
      ],
    }),

    computed: {
      minHeight () {
      return this.$vuetify.breakpoint.mdAndUp
        ? '90vh'
        : 'none'
      },
    },
  }
</script>

<style>
#heading1, #heading2 {
  color: white !important;
  text-shadow: 2px 2px 1px black;
}
#img1 > .v-image__image, #img2 > .v-image__image {
  background-position: unset !important;
}

@media (max-width: 960px) {
  .mt-mobile {
    margin-top: 2rem !important; /* Increase this value for more space */
  }
}
</style>
